import React, { useState, useEffect } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { IconButton } from '@hz-design-system/web-ui';

import AdmarktRegistrarionStepCustomerRecommend from './AdmarktRegistrationStepCustomerRecommend';

import recommendPersonImage from '../../../../images/admarkt/social-proof-all-sanne.svg';
import tireCustomerImage from '../../../../images/admarkt/tire-man.png';
import ttmCustomerImage from '../../../../images/admarkt/ttm-man.png';

import recommendSignImage from '../../../../images/admarkt/recommend-sign.svg';
import tireLogoImage from '../../../../images/admarkt/tire-logo.png';
import ttmLpgpImage from '../../../../images/admarkt/ttm-logo.png';

import Classes from './AdmarktRegistrationStepCustomerRecommend.module.scss';

const customerTestimonyData = [
  {
    text: 'admarktRegistration.step.recommend.text1',
    name: 'admarktRegistration.step.recommend.name1',
    imgSrc: recommendSignImage,
    customerImgSrc: recommendPersonImage,
  },
  {
    text: 'admarktRegistration.step.recommend.text2',
    name: 'admarktRegistration.step.recommend.name2',
    imgSrc: tireLogoImage,
    customerImgSrc: tireCustomerImage,
  },
  {
    text: 'admarktRegistration.step.recommend.text3',
    name: 'admarktRegistration.step.recommend.name3',
    imgSrc: ttmLpgpImage,
    customerImgSrc: ttmCustomerImage,
  },
];

const AdmkartRegistrarionStepRecommend = () => {
  const lastSlideIndex = customerTestimonyData.length - 1;
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const currentIndex = parseInt(entry.target.id.substr(-1), 10);
              setCurrentSlide(currentIndex);
              obs.unobserve(entry.target);
            }
          });
        },
        { root: document.querySelector(`.${Classes.slides}`), rootMargin: '0px', threshold: 0.5 },
      );
      document.querySelectorAll(`.${Classes.slide}`).forEach((slide) => {
        observer.observe(slide);
      });
    }
  }, []);

  const handleOnNextClick = () => {
    let activeElement;
    if (currentSlide < lastSlideIndex) {
      activeElement = document.querySelector(`#slide${currentSlide + 1}`);
      setCurrentSlide(currentSlide + 1);
    } else if (currentSlide === lastSlideIndex) {
      activeElement = document.querySelector(`#slide0`);
      setCurrentSlide(0);
    }
    if (activeElement) {
      activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  };

  return (
    <div className={Classes.recommendBlock}>
      <Trans tagName="h5" i18nKey="admarktRegistration.steps.info_block.recommendation_title" />
      <div className={Classes.flexDiv}>
        <div className={Classes.sliderContainer}>
          <div className={Classes.slides}>
            {customerTestimonyData.map((data, index) => (
              <AdmarktRegistrarionStepCustomerRecommend
                comment={data.text}
                recommendName={data.name}
                imgSrc={data.imgSrc}
                customerImgSrc={data.customerImgSrc}
                key={data.name}
                index={index}
                activeSlide={currentSlide}
              />
            ))}
          </div>
        </div>
        <div className={Classes.nextBtnContainer}>
          <IconButton.Primary name="arrow-right-regular" ariaLabel="arrow-right" onClick={handleOnNextClick} />
        </div>
      </div>
      <div className={Classes.paginationContainer}>
        {customerTestimonyData.map((data, index) => (
          <div key={data.name} className={currentSlide === index ? Classes.active : undefined} />
        ))}
      </div>
    </div>
  );
};

export default AdmkartRegistrarionStepRecommend;
